module.exports = __webpack_public_path__ + "img/9-black+.2b8d18dc.png";